// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Search-ActionButton.module.scss  */
.Search-ActionButton-module-Root_KXw {
  width: 40px;
  height: 40px;
  margin: 0;
  padding: 0;
  user-select: none;
  color: var(--search-action-button-color);
  border-width: 0;
  border-radius: 50%;
  outline: 0;
  background: transparent;
  -moz-user-focus: ignore;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  touch-action: manipulation; }
  .Search-ActionButton-module-Root_KXw:active {
    background-color: var(--search-action-button-background-color-pressed); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Search/ActionButton/Search-ActionButton.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,uBAAuB;EACvB,6CAA6C;EAC7C,0BAA0B,EAAE;EAC5B;IACE,sEAAsE,EAAE","sourcesContent":["/*  imported from Search-ActionButton.module.scss  */\n.Search-ActionButton-module-Root_KXw {\n  width: 40px;\n  height: 40px;\n  margin: 0;\n  padding: 0;\n  user-select: none;\n  color: var(--search-action-button-color);\n  border-width: 0;\n  border-radius: 50%;\n  outline: 0;\n  background: transparent;\n  -moz-user-focus: ignore;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  touch-action: manipulation; }\n  .Search-ActionButton-module-Root_KXw:active {\n    background-color: var(--search-action-button-background-color-pressed); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
